import React, { forwardRef, useImperativeHandle } from "react";
import { Modal } from "react-bootstrap";

import { Box, Button, Heading } from "../elements";
import { AddYard } from "./AddYard";

export const AddYardModal = forwardRef(({ show, setShow, inputData, handleChange, handleCloseModal, handleSubmit }, ref) => {
  useImperativeHandle(ref, () => ({
    onShowModal() {
      setShow(true);
    },
  }));

  return (
    <Modal show={show}>
      <Box style={{ padding: 16, paddingTop: 0, minWidth: 600 }}>
        <Heading as="h5" className="textAlignLeft" style={{ marginBottom: 16 }}>
          Add Yard
        </Heading>
        <AddYard inputData={inputData} handleChange={handleChange} />

        <Modal.Footer className="alignAllRight">
          <Button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button type="button" className="btn btn-primary" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Box>
    </Modal>
  );
});
